// Changer la forme au survol du menu
if (window.innerWidth > 960) {
    let menu = document.querySelector(".header-bottom .nav-menu");
    let menuItems = document.querySelectorAll(".header-bottom .nav-menu__item.menu-item-has-children");

    for (let i = 0; i < menuItems.length; i++) {
        menuItems[i].addEventListener("mouseover", doSomething, false);
        menuItems[i].addEventListener("mouseleave", doNotSomething, false);
        menuItems[i].addEventListener("focusin", doSomething, false);
        menuItems[i].addEventListener("focusout", doNotSomething, false);
    }

    function doSomething() {
        menu.classList.add('nav-menu--open');
    }

    function doNotSomething() {
        menu.classList.remove('nav-menu--open');
    }
}


else {
    var menuOpen = document.querySelector('.nav-burger__icon');
    var menuClose = document.querySelector('.nav-content__close');
    var subMenuBack = document.querySelector('.nav-submenu__back');
    var subMenuClose = document.querySelector('.nav-submenu__close');
    var menuItems = document.querySelectorAll('.nav-menu__item');

    menuOpen.addEventListener('click', function () {
        document.querySelector('.nav-main').classList.add('nav-main--active');
    });

    menuClose.addEventListener('click', function () {
        document.querySelector('.nav-main').classList.remove('nav-main--active');
    });

    subMenuClose.addEventListener('click', function () {
        document.querySelector('.nav-main').classList.remove('nav-main--active');
    });

    subMenuBack.addEventListener('click', function () {
        menuItems.forEach(function (item) {
            this.classList.toggle('active')
        });
    });

    menuItems.forEach(function (item) {
        item.addEventListener('click', function () {
            var activeItem = document.querySelector('.nav-menu__item--active')
            this.classList.toggle('nav-menu__item--active');

            if (activeItem) {
                activeItem.classList.remove('nav-menu__item--active');
            }
        });
    });
}